import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { useDeleteManySharedKnowledgeFilesService } from '@/services/sharedFiles';
import { type FC } from 'react';

export const DeleteManyFilesModal: FC<{
  fileIds: string[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
}> = ({ fileIds, open, onOpenChange, onSuccess }) => {
  const { deleteManyFiles } = useDeleteManySharedKnowledgeFilesService();

  const handleDelete = () => {
    deleteManyFiles(
      { fileIds },
      {
        onSuccess: () => {
          onOpenChange(false);
          onSuccess?.();
        },
        onError: error => {
          console.error('Failed to delete files:', error);
        },
      }
    );
  };

  const fileCount = fileIds.length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete Files</DialogTitle>
          <DialogDescription>
            Delete the selected files from the shared knowledge.
          </DialogDescription>
        </DialogHeader>
        <Text>
          {`Are you sure you want to delete ${fileCount} file${
            fileCount === 1 ? '' : 's'
          }?`}
        </Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleDelete}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
